import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Typography } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';

import CustomIcon from '../CustomIcon';
import EmptyState from '../EmptyState';
import { moment } from '../../../I18n';
import { Icons } from '../../../Themes';

function EventUrlState({ startAt, endAt, url }: any) {
  const intl = useIntl();
  const future = moment(startAt).isAfter();
  const past = moment(endAt).isBefore();
  const isOngoing = !future && !past;

  let text = <FormattedMessage id="POSTS.DETAILS.EVENT.STATE.ONGOING" />;
  if (future) {
    const momentDefaultDate = intl.formatMessage({ id: 'MOMENT.DATE.DEFAULT' });
    text = (
      <FormattedMessage
        id="POSTS.DETAILS.EVENT.STATE.FUTURE"
        values={{
          date: moment(startAt).format(momentDefaultDate),
          time: moment(startAt).format('LT'),
          b: (chunks: any) => <b>{chunks}</b>,
        }}
      />
    );
  } else if (past) {
    text = <FormattedMessage id="POSTS.DETAILS.EVENT.STATE.PAST" />;
  }

  return (
    <EmptyState
      icon={<CustomIcon src={Icons.misc.accessPoint} color="primary" size={30} />}
      content={<Typography variant="body1">{text}</Typography>}
      action={
        isOngoing ? (
          <Button
            size="large"
            variant="contained"
            color="primary"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            endIcon={<LaunchIcon />}
            title={intl.formatMessage({ id: 'BUTTONS.OPEN_IN_NEW_TAB' })}
          >
            <FormattedMessage id="POSTS.DETAILS.EVENT.ACCESS_THE_EVENT" />
          </Button>
        ) : null
      }
    />
  );
}

EventUrlState.propTypes = {
  endAt: PropTypes.string.isRequired,
  startAt: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default EventUrlState;
